import React from 'react';
import { useField } from 'formik';
import {
  Slider,
  Typography
} from '@material-ui/core';

function MySlider(props) {
  let [field, meta, helpers] = useField(props.name);
  return (
    <React.Fragment>
      <Typography gutterBottom>
        How is your Snatch and Clean & Jerk technique?
      </Typography>
      <Slider
        {...props}
        component="div"
        onChangeCommitted={(_, value) => {
          helpers.setValue(value);
        }}
        style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%' }}
      />
    </React.Fragment>
  );
}

export default MySlider;